<template>
    <div class="validation-failed-box">
        <div class="d-flex justify-content-between align-items-start">
            <div class="d-flex align-items-start failed-info">
                <span class="failed-icon">&#9888;</span>
                <div>
                    <p class="failed-title mb-0">Terdapat {{ failedItems.length }} item gagal divalidasi</p>
                    <p class="failed-subtitle mb-0">
                        Item bermasalah tidak dapat diproses karena kendala yang tertera pada detail.
                    </p>
                </div>
            </div>
            <div class="d-flex align-items-center failed-actions">
                <button class="btn-revalidate" :disabled="loading" @click="$emit('validasi-ulang')">
                    <span class="refresh-icon">&#8635;</span>
                    {{ loading ? 'Memvalidasi...' : 'Validasi Ulang' }}
                </button>
                <button class="btn-toggle-expand" @click="expanded = !expanded">
                    <span :class="['chevron', { 'chevron-up': expanded }]">&#9662;</span>
                </button>
            </div>
        </div>

        <div class="failed-items-table-wrapper" v-if="expanded">
            <table class="failed-items-table">
                <thead>
                    <tr>
                        <th>KATEGORI</th>
                        <th>REFERENCE</th>
                        <th>NAMA ITEM</th>
                        <th>KETERANGAN</th>
                        <th v-if="showAction">AKSI</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, idx) in failedItems" :key="idx">
                        <td><span class="category-badge">{{ item.category }}</span></td>
                        <td>{{ item.reference }}</td>
                        <td>{{ item.itemName || '-' }}</td>
                        <td class="reason-text">{{ item.reason }}</td>
                        <td v-if="showAction">
                            <button
                                v-if="item.action"
                                class="btn-action"
                                @click="$emit('aksi-item', item, idx)"
                            >{{ item.actionLabel }}</button>
                            <span v-else class="no-action">-</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ValidationFailedBox',
    props: {
        failedItems: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        showAction: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            expanded: true,
        };
    },
};
</script>

<style scoped>
.validation-failed-box {
    background: #fdecea;
    border: 1px solid #f6c6c8;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 20px;
}

.failed-info {
    gap: 10px;
}

.failed-icon {
    color: #dc3545;
    font-size: 16px;
    line-height: 1.4;
}

.failed-title {
    font-size: 13px;
    font-weight: 600;
    color: #dc3545;
}

.failed-subtitle {
    font-size: 12px;
    color: #a94442;
}

.failed-actions {
    white-space: nowrap;
    gap: 4px;
}

.btn-revalidate {
    border: none;
    background: transparent;
    color: #0d6efd;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 6px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.btn-revalidate:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.refresh-icon {
    font-size: 13px;
}

.btn-toggle-expand {
    border: none;
    background: transparent;
    color: #6c757d;
    padding: 4px 6px;
}

.chevron {
    display: inline-block;
    transition: transform 0.2s ease;
}

.chevron-up {
    transform: rotate(180deg);
}

.failed-items-table-wrapper {
    margin-top: 12px;
    border: 1px solid #f1c3c5;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.failed-items-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
}

.failed-items-table thead th {
    background-color: #fbf7f7;
    font-size: 11px;
    font-weight: 700;
    color: #868e96;
    text-transform: uppercase;
    text-align: left;
    border-bottom: 1px solid #f1c3c5;
    border-right: 1px solid #f1c3c5;
    padding: 10px 16px;
    white-space: nowrap;
}

.failed-items-table tbody td {
    font-size: 13px;
    color: #343a40;
    vertical-align: middle;
    border-bottom: 1px solid #f5e6e6;
    border-right: 1px solid #f5e6e6;
    padding: 12px 16px;
}

.failed-items-table thead th:last-child,
.failed-items-table tbody td:last-child {
    border-right: none;
}

.failed-items-table tbody tr:last-child td {
    border-bottom: none;
}

.category-badge {
    display: inline-block;
    padding: 3px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 500;
    color: #495057;
    background: #fff;
    border: 1px solid #dee2e6;
    white-space: nowrap;
}

.failed-items-table tbody td.reason-text {
    color: #CC444A;
}

.no-action {
    color: #adb5bd;
}

.btn-action {
    border: none;
    background: #0d6efd;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 16px;
    border-radius: 20px;
    white-space: nowrap;
}

.btn-action:hover {
    background: #0b5ed7;
}
</style>



// WEBPACK FOOTER //
// src/components/Disposal/CustomComponent/ValidationFailedBox.vue